﻿import OrderMatterportApi from "./OrderMatterportApi";


export function sendMatterportLinks(orderId: number, brokerAgentEmail:string, url:string):Promise<void>{
    return OrderMatterportApi.sendMatterportLinks(orderId, brokerAgentEmail, url);
}